import React, { Fragment } from 'react';
import { keysIn } from 'lodash';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import StyledTableCell from '../tabel-component/StyledTableCell';
import HeaderTableCell from '../tabel-component/HeaderTableCell';
import TableLoader from '../tabel-component/TableLoader';
import { aixmFeatureKeyMap } from '../../constants/aixmData';

export default function AeronauticalGroundLightItem({
  isLoading,
  category,
  airportDetails,
  aixmFeatureMapData,
  selctedAirport
}) {
  const aeronauticalGroundLightList = airportDetails[category];
  const aeronauticalGroundLightMap = aixmFeatureMapData['AeronauticalGroundLight_list'];
  const aeronauticalGroundLightNotestMap = aixmFeatureMapData['notes_list'];

  return (
    <Fragment>
      {(isLoading || aeronauticalGroundLightList.length === 0) && (
        <TableLoader isLoading={isLoading} data={aeronauticalGroundLightList} />
      )}
      {
        aeronauticalGroundLightList.map((agl, i) => {
          return (
            <Paper sx={{ mb: 5 }} key={`${category}_${i}`}>
              <Table>
                <TableHead>
                  <TableRow>
                    <HeaderTableCell colSpan={2}>
                      {selctedAirport.name} {">"} {aixmFeatureKeyMap[category]} {agl.designator}
                    </HeaderTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {keysIn(aeronauticalGroundLightMap).map((key, j) => {
                    const aglKey = aeronauticalGroundLightMap[key];

                    return (
                      <TableRow
                        key={j}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <StyledTableCell style={{ width: 200 }}>{key}</StyledTableCell>
                        <StyledTableCell>{agl[aglKey] || "-"}</StyledTableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell colSpan={2}>Notes</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {keysIn(aeronauticalGroundLightNotestMap).map((key, j) => {
                    const aglNoteKey = aeronauticalGroundLightNotestMap[key];

                    return (
                      <TableRow
                        key={j}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <StyledTableCell style={{ width: 200 }}>{key}</StyledTableCell>
                        <StyledTableCell>{agl["notes"][aglNoteKey] || "-"}</StyledTableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            </Paper>
          );
        })
      }
    </Fragment>
  );
}
